import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { equals, gt, length, lt } from "ramda";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useSelected } from "../../organize/OrganizeProvider";

const useStyles = makeStyles(theme => ({
  label: {
    fontWeight: 700,
    color: theme.palette.darker,
    fontSize: "1.6rem",
    lineHeight: "24px",
  },
}));

const SelectedModuleFilesCheckbox = ({ content, total = null }) => {
  const classes = useStyles();
  const { selectedContent, removeAllSelectedContent } = useSelected();

  const [checkbox, setCheckbox] = useState({
    checked: false,
    indeterminate: false,
  });
  useEffect(() => {
    if (gt(length(selectedContent), 0)) {
      const count = total || length(content);
      setCheckbox({
        checked: equals(length(selectedContent), count),
        indeterminate: lt(length(selectedContent), count),
      });
    }
  }, [content, selectedContent, total]);

  const handleChange = event => {
    removeAllSelectedContent();
  };

  return (
    <Grid item style={{ paddingLeft: 15 }}>
      <FormControlLabel
        label={
          <Typography className={classes.label}>
            {`${length(selectedContent)} selected`}
          </Typography>
        }
        control={
          <Checkbox
            color="primary"
            indeterminate={checkbox.indeterminate}
            checked={checkbox.checked}
            onChange={handleChange}
            inputProps={{ "aria-label": "Select" }}
          />
        }
      />
    </Grid>
  );
};

export default SelectedModuleFilesCheckbox;
